import React, { useCallback, useState } from 'react';
import { styled } from '@mui/system';
import { Box, Tab as BaseTab } from '@mui/material';
import { TabContext, TabList as BaseTabsList, TabPanel as BaseTabPanel } from '@mui/lab';
import { blue, grey } from '@mui/material/colors';
import { PrePayrollVariants } from './PrePayrollVariants';
import { useSelector } from 'react-redux';
import PrePayrollStatus from './PrePayrollStatus';

export default function PrePayrollTabs(props) {
  const { prePayrollsObj } = useSelector(state => state.prePayroll)
  const { prePayroll } = prePayrollsObj
  const [value, setValue] = useState(0);

  const handleChange = useCallback((_event, newValue) => setValue(newValue), []);

  return (
    <Box style={{marginTop: 20}}>
      <Box style={{marginBottom: 20}}>
        <PrePayrollStatus periodsHandler={props}/>
      </Box>
      <TabContext value={value}>
        <TabList onChange={handleChange} variant="fullWidth" aria-label="prePayroll Tabs">
          { Object.keys(prePayroll).map((key, indx) => <Tab key={key} value={indx} label={key}/>) }
        </TabList>
        { Object.keys(prePayroll).map((key, indx) => 
          <TabPanel key={key} value={indx}>
            <PrePayrollVariants prePayroll={prePayroll[key]}/>
          </TabPanel>
        )}
      </TabContext>
    </Box>
  );
}

const Tab = styled(BaseTab)`
  color: #fff;
  opacity: 1;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: transparent;
  width: 100%;
  min-height: 0px;
  padding: 10px 12px;
  margin: 6px;
  border: none;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  text-transform: none;

  &:hover {
    background-color: ${blue[800]};
  }

  &:focus {
    color: #fff;
  }

  &.Mui-selected {
    background-color: #fff;
    color: ${blue[900]};
  }
`;

const TabPanel = styled(BaseTabPanel)(
  ({ theme }) => `
  width: 100%;
  padding: 20px 12px;
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  border-radius: 12px;
  `,
);

const TabList = styled(BaseTabsList)(
  ({ theme }) => `
  background-color: ${blue[900]};
  border-radius: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  box-shadow: 0px 4px 30px ${theme.palette.mode === 'dark' ? grey[900] : grey[200]};

  & .MuiTabs-indicator {
    display: none
  }
  `,
);